module.exports = __webpack_public_path__ + "img/hero-air-01.f628ca28.png";